import type { FC } from 'react'

import { NameAvatar } from '@skytech/ui/NameAvatar'
import { Td } from '@skytech/ui/Table/Td'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'
import { APP_ROUTES } from '@/util/app-routes'

import type { InjuryReport } from '../types'

export const InjuryReportListItem: FC<InjuryReport & { searchFilter: string }> = ({
  id,
  userName,
  assetDescription,
  injuryDate,
  created,
  searchFilter,
  status,
}) => {
  const translate = useTranslation()

  return (
    <TrLink path={APP_ROUTES.HARDWARE_INJURY_REPORT.replace(':id', String(id))}>
      <Td className="is-mobile-hidden">
        <NameAvatar name={userName} />
      </Td>
      <Td className="mobile-view">
        <div className="mobile-view__user">
          <Highlight pattern={searchFilter} text={userName} />
        </div>

        <div className="is-mobile-hidden">
          <Highlight pattern={searchFilter} text={assetDescription} />
        </div>

        <div className="mobile-view__status">
          <Translation id={`injury_report_status/${status}`} />
        </div>

        <div className="mobile-view__date">{injuryDate && <LocalDate date={injuryDate} />}</div>
      </Td>
      <Td className="is-mobile-hidden">
        <Highlight pattern={searchFilter} text={userName} />
      </Td>

      <Td className="is-mobile-hidden">
        <Highlight pattern={searchFilter} text={assetDescription} />
      </Td>

      <Td className="is-mobile-hidden">
        <Highlight pattern={searchFilter} text={translate(`injury_report_status/${status}`)} />
      </Td>
      <Td className="is-mobile-hidden">{injuryDate && <LocalDate date={injuryDate} />}</Td>
      <Td className="is-mobile-hidden">
        <LocalDate date={created} />
      </Td>
    </TrLink>
  )
}

export default InjuryReportListItem
